export default class Overlay {
  constructor() {
    this.overlayId = 'overlayElement';
    this.overlayClass = 'overlay';
    this.overlayDataAttr = 'data-overlay-element';
    this.isMacOS = navigator.userAgent.indexOf('Mac') > -1;
  }

  getOverlay() {
    return document.getElementById(this.overlayId);
  }

  create() {
    requestAnimationFrame(() => {
      if (this.getOverlay()) {
        return;
      }

      if (this.isMacOS) {
        document.body.classList.add('macOS');
      }
      
      document.body.classList.add('body-no-scrolleable');
      document.body.insertAdjacentHTML('beforeend', this.getHtml());
    });
  }

  remove() {
    requestAnimationFrame(() => {
      const overlay = this.getOverlay();
      if (!overlay) {
        return;
      }

      if (this.isMacOS) {
        document.body.classList.remove('macOS');
      }
      
      document.body.classList.remove('body-no-scrolleable');
  
      overlay.remove();
    });
  }

  getHtml() {
      return `<div id="${this.overlayId}" class="${this.overlayClass}" ${this.overlayDataAttr}></div>`;
  }
}
